import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { System } from '../../../shared-components/System';
import { UserService } from '../../../shared-components/user/user.service';
import { YearService } from '../../../shared-components/year/year.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { CurrentWork, OverdueAlert, SpecialServiceTeam, SpedCalendar, SpEdGradeLevel, SpedHomeMyEvent, SpedHomePanel, SpEdSite, DocumentWaitingApproval, SpedCollectionIep, BehaviorAlerts, StudentList, ComplianceResult, SpEdPanel } from './sped-cards.model';

@Injectable({
  providedIn: 'root'
})
export class SpedCardsService {

  spedHomePanels: SpedHomePanel[] = [];
  userId: number;
  private _callForSaveXmlData = false;
  public get callForSaveXmlData(): boolean {
    return this._callForSaveXmlData;
  }

  public set callForSaveXmlData(value: boolean) {
    this._callForSaveXmlData = value;
    this.observableCallForSaveXmlData.next(value);
  }

  public observableCallForSaveXmlData = new Subject<boolean>();
  observableCallForSaveXmlDataStream$ = this.observableCallForSaveXmlData.asObservable();

  private _selectedSiteId: number;
  public get selectedSiteId(): number {
    return this._selectedSiteId;
  }

  public set selectedSiteId(value: number) {
    this._selectedSiteId = value;
    this.observableSelectedSiteId.next(value);
  }

  public observableSelectedSiteId = new Subject<number>();
  observableSelectedSiteIdStream$ = this.observableSelectedSiteId.asObservable();

  private _selectedGradeLevelId: number;
  public get selectedGradeLevelId(): number {
    return this._selectedGradeLevelId;
  }

  public set selectedGradeLevelId(value: number) {
    this._selectedGradeLevelId = value;
    this.observableSelectedGradeLevelId.next(value);
  }

  public observableSelectedGradeLevelId = new Subject<number>();
  observableSelectedGradeLevelIdStream$ = this.observableSelectedGradeLevelId.asObservable();

  private _selectedSpecialServiceId: number;
  public get selectedSpecialServiceId(): number {
    return this._selectedSpecialServiceId;
  }

  public set selectedSpecialServiceId(value: number) {
    this._selectedSpecialServiceId = value;
    this.observableselectedSpecialServiceId.next(value);
  }

  public observableselectedSpecialServiceId = new Subject<number>();
  observableselectedSpecialServiceIdStream$ = this.observableselectedSpecialServiceId.asObservable();

  private _selectedDays: number;
  public get selectedDays(): number {
    return this._selectedDays;
  }

  public set selectedDays(value: number) {
    this._selectedDays = value;
    this.observableSelectedDays.next(value);
  }

  public observableSelectedDays = new Subject<number>();
  observableSelectedDaysStream$ = this.observableSelectedDays.asObservable();

  private _selectedPanel: string;
  public get selectedPanel(): string {
    return this._selectedPanel;
  }

  public set selectedPanel(value: string) {
    this._selectedPanel = value;
    this.observableSelectedPanel.next(value);
  }

  public observableSelectedPanel = new Subject<string>();
  observableSelectedPanelStream$ = this.observableSelectedPanel.asObservable();

  private _selectedValueFromDD: any;
  public get selectedValueFromDD(): any {
    return this._selectedValueFromDD;
  }

  public set selectedValueFromDD(value: any) {
    this._selectedValueFromDD = value;
    this.observableSelectedValueFromDD.next(value);
  }

  public observableSelectedValueFromDD = new Subject<any>();
  observableSelectedValueFromDDStream$ = this.observableSelectedValueFromDD.asObservable();


  constructor(private http: HttpClient, private yearService: YearService, private loginService: LoginService, private userService: UserService) { }

  siteReadByUserId(): Observable<SpEdSite[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id;
    return this.http.get<SpEdSite[]>(System.apiURL.SpecialEd + 'SiteReadByUserId' + queryString);
  }

  getGradeLevel(): Observable<SpEdGradeLevel[]> {
    return this.http.get<SpEdGradeLevel[]>(System.apiURL.SpecialEd + 'GetGradeLevel');
  }

  getCurrentWorkList(siteId: number, gradeLevelId: number, type: number): Observable<CurrentWork[]> {
    const queryString = '?stateCode=' + this.loginService.LoginSettings.State + '&siteYearId=' + this.yearService.defaultYear.SiteYearId + '&siteId=' + siteId + '&yearId=' + this.yearService.defaultYear.Id + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<CurrentWork[]>(System.apiURL.SpecialEd + 'GetCurrentWorkList' + queryString);
  }

  getSpedHomePanelList(): Observable<SpedHomePanel[]> {
    return this.http.get<SpedHomePanel[]>(System.apiURL.SpecialEd + 'SpedHomePanelsRead');
  }
  getOverDueAlertData(stateCode: string, siteYearId: number, siteId: number, yearId: number, gradeLevelId: number, type: number): Observable<OverdueAlert[]> {
    const queryString = '?stateCode=' + stateCode + '&siteYearId=' + siteYearId + '&siteId=' + siteId + '&yearId=' + yearId + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<OverdueAlert[]>(System.apiURL.SpecialEd + 'OverdueAlertsListRead' + queryString);
  }

  getMySpecialServiceTeam(stateCode: string, siteYearId: number, siteId: number, yearId: number, gradeLevelId: number, type: number): Observable<SpecialServiceTeam[]> {
    const queryString = '?stateCode=' + stateCode + '&siteYearId=' + siteYearId + '&siteId=' + siteId + '&yearId=' + yearId + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<SpecialServiceTeam[]>(System.apiURL.SpecialEd + 'MyTeamsListRead' + queryString);
  }

  getSpedHomeMyEvent(stateCode: string, siteYearId: number, siteId: number, yearId: number, days: number, gradeLevelId: number, type: number): Observable<SpedHomeMyEvent[]> {
    const queryString = '?stateCode=' + stateCode + '&siteYearId=' + siteYearId + '&siteId=' + siteId + '&yearId=' + yearId + '&days=' + days + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<SpedHomeMyEvent[]>(System.apiURL.SpecialEd + 'MyEventsListRead' + queryString);
  }

  studentListRead(stateCode: string, siteYearId: number, siteId: number, yearId: number, gradeLevelId: number, type: number): Observable<StudentList[]> {
    const queryString = '?stateCode=' + stateCode + '&siteYearId=' + siteYearId + '&siteId=' + siteId + '&yearId=' + yearId + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<StudentList[]>(System.apiURL.SpecialEd + 'StudentsListRead' + queryString);
  }

  getSpedCalenderDetails(siteId: number, gradeLevelId: number, type: number): Observable<SpedCalendar[]> {
    const queryString = '?stateCode=' + this.loginService.LoginSettings.State + '&siteYearId=' + this.yearService.defaultYear.SiteYearId + '&siteId=' + siteId + '&yearId=' + this.yearService.defaultYear.Id + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<SpedCalendar[]>(System.apiURL.SpecialEd + 'CalendarDataRead' + queryString);
  }

  spedCollectionRead(): Observable<SpedCollectionIep[]> {
    return this.http.get<SpedCollectionIep[]>(System.apiURL.SpecialEd + 'SpedCollectionRead');
  }

  documentsWaitingApprovalReadByDocType(stateCode: string, siteYearId: number, siteId: number, yearId: number, gradeLevelId: number, spedCollectionId: number, manageDocumentStatus: boolean, type: number): Observable<DocumentWaitingApproval[]> {
    const queryString = '?stateCode=' + stateCode + '&siteYearId=' + siteYearId + '&siteId=' + siteId + '&yearId=' + yearId + '&gradeLevelId=' + gradeLevelId + '&spedCollectionId=' + spedCollectionId + '&manageDocumentStatus=' + manageDocumentStatus + '&type=' + type;
    return this.http.get<DocumentWaitingApproval[]>(System.apiURL.SpecialEd + 'DocumentsWaitingApprovalReadByDocType' + queryString);
  }


  viewContentDocument(spedCollectionId: number, studentId: number, spedCollectionToStudentId: number, collectionStatusId: number, templateVersionId: number, siteId: number, yearId: number, callFromHomePage: boolean, studentTemplateVersionIds: string, studentHeader: boolean): Observable<string> {
    let queryString = '';
    queryString += '?spedCollectionId=' + spedCollectionId +
      '&studentId=' + studentId +
      '&spedCollectionToStudentId=' + spedCollectionToStudentId +
      '&collectionStatusId=' + collectionStatusId +
      '&templateVersionId=' + templateVersionId +
      '&siteId=' + siteId +
      '&yearId=' + yearId +
      '&callFromHomePage=' + callFromHomePage +
      '&studentTemplateVersionIds=' + studentTemplateVersionIds +
      '&studentHeader=' + studentHeader;
    return this.http.get<string>(System.apiURL.SpecialEd + 'ViewSpEdCollectionDocument' + queryString);
  }

  studentDocumentStatusUpdate(spedCollectionToStudentId: number, viewDocumentBeforeApproval: boolean, sendBack: boolean, callFromComplianceResult: boolean, hasOverrideErrorPermission: boolean): Observable<string> {
    const queryString = '?spedCollectionToStudentId=' + spedCollectionToStudentId +
      '&viewDocumentBeforeApproval=' + viewDocumentBeforeApproval +
      '&sendBack=' + sendBack +
      '&callFromComplianceResult=' + callFromComplianceResult +
      '&hasOverrideErrorPermission=' + hasOverrideErrorPermission;
    return this.http.get<string>(System.apiURL.SpecialEd + 'StudentDocumentStatusUpdate' + queryString);
  }
  studentDocumentStatusMassUpdate(spedCollectionToStudentIds: string[], viewDocumentBeforeApproval: boolean, sendBack: boolean, callFromComplianceResult: boolean, hasOverrideErrorPermission: boolean): Observable<any> {
    const queryString = '?spedCollectionToStudentIds=' + spedCollectionToStudentIds +
      '&viewDocumentBeforeApproval=' + viewDocumentBeforeApproval +
      '&sendBack=' + sendBack +
      '&callFromComplianceResult=' + callFromComplianceResult +
      '&hasOverrideErrorPermission=' + hasOverrideErrorPermission;
    return this.http.get<string>(System.apiURL.SpecialEd + 'StudentDocumentStatusMassUpdate' + queryString);
  }

  getBehaviorAlerts(stateCode: string, siteYearId: number, siteId: number, yearId: number, days: number, gradeLevelId: number, type: number): Observable<BehaviorAlerts[]> {
    const queryString = '?stateCode=' + stateCode + '&siteYearId=' + siteYearId + '&siteId=' + siteId + '&yearId=' + yearId + '&days=' + days + '&gradeLevelId=' + gradeLevelId + '&type=' + type;
    return this.http.get<BehaviorAlerts[]>(System.apiURL.SpecialEd + 'DisciplineAlertsListRead' + queryString);
  }

  getComplianceDocument(spedCollectionToStudentId: number): Observable<ComplianceResult[]> {
    const queryString = '?spedCollectionToStudentId=' + spedCollectionToStudentId;
    return this.http.get<ComplianceResult[]>(System.apiURL.SpecialEd + 'SpEdDocumentComplianceRead' + queryString);
  }

  spedPanelUpdate(spedPanel: SpEdPanel): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SpedHomePanelUpdate', spedPanel);

  }
  editHTMLDocument(spedCollectionId: number, studentId: number, spedCollectionToStudentId: number, StudentCollectionTemplateVersionId: number, collectionStatusId: number, templateVersionId: number, templateName: string, siteId: number, yearId: number): Observable<string> {
    this.userId = this.userService.currentUser.Id;
    let queryString = '';
    queryString += '?spedCollectionId=' + spedCollectionId +
      '&studentId=' + studentId +
      '&spedCollectionToStudentId=' + spedCollectionToStudentId +
      '&StudentCollectionTemplateVersionId=' + StudentCollectionTemplateVersionId +
      '&collectionStatusId=' + collectionStatusId +
      '&templateVersionId=' + templateVersionId +
      '&templateName=' + templateName +
      '&userId=' + this.userId +
      '&siteId=' + siteId +
      '&yearId=' + yearId;
    return this.http.get<string>(System.apiURL.SpecialEd + 'ViewEditSpEdForm' + queryString);
  }

  saveHTMLDocument(strHtmlFormData: string, studentId: number, spedCollectionToStudentId: number, templateVersionId: number, templateName: string, studentCollectionTemplateVersionId: number, stateCode: string, changeStatus: string, yearId: number): Observable<void> {
    let queryString = '';
    queryString += '?studentId=' + studentId +
      '&studentCollectionId=' + spedCollectionToStudentId +
      '&templateVersionId=' + templateVersionId +
      '&templateName=' + templateName +
      '&studentCollectionTemplateVersionId=' + studentCollectionTemplateVersionId +
      '&stateCode=' + stateCode +
      '&changeStatus=' + changeStatus +
      '&yearId=' + yearId;

    return this.http.post<void>(System.apiURL.SpecialEd + 'SaveHTMLFormData' + queryString, [strHtmlFormData]);
  }

  spedHTMLStudentCollectionStatusTemplatesItemsRead(studentCollectionId: number, showLatestVersion: boolean, spEdcollectionId: number): Observable<any[]> {
    let queryString = '';
    queryString += '?studentCollectionId=' + studentCollectionId +
      '&showLatestVersion=' + showLatestVersion +
      '&spEdcollectionId=' + spEdcollectionId;
    return this.http.get<any[]>(System.apiURL.SpecialEd + 'SpedHTMLStudentCollectionStatusTemplatesItemsRead' + queryString);
  }
}
